export class SsrData {
  constructor(private storage: SsrDataPayload = {}) {}

  slot = <T>(name: string, init: () => T): T => {
    if (!Object.prototype.hasOwnProperty.call(this.storage, name)) {
      this.storage[name] = init();
    }

    /** Unsafe coercion allowed here on the assumption that no two consumers will use the same name
     *  for a different datatype. */
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return this.storage[name] as T;
  };

  serialise = () => this.storage;
}

export type SsrDataPayload = Record<string, unknown>;
